<template>
  <div class="contact-wrapper">
    <div class="contact py-4">
      <div class="contact-item">
        <span class="color--primary fw-600"> Ficou alguma dúvida? </span>
      </div>
      <div class="contact-item">
        <Icon class="icon mx-1" name="globe" />
        <a
          :href="`${
            arData.siteAR.includes('https://')
              ? arData.siteAR
              : `https://${arData.siteAR}`
          }`"
          class="link"
        >
          {{ getSiteArFormatted }}
        </a>
      </div>
      <div class="contact-item">
        <Icon class="icon mx-1" name="phone" />
        <span>{{ arData.foneAR }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { mapState } from 'pinia'
  import { useAR } from '@/store/Pinia/useAR.store'

  export default defineComponent({
    name: 'ContactContent',
    computed: {
      ...mapState(useAR, ['arData', 'getSiteArFormatted']),
    },
    components: {
      Icon,
    },
  })
</script>

<style lang="stylus" scoped>
  .contact-wrapper
    display: flex
    justify-content: center
    margin-top: 2rem
    width: 100%
  .contact
    display: flex
    flex-wrap: wrap
    justify-content: center
    width: 100%
    gap: 1rem;
    border: 1px solid #E6E7EC
    border-radius: 10px
  .contact-item
    display: flex
    align-items: center
    gap: 0.5rem

  @media screen and (max-width: 575px)
    .contact-wrapper
      .contact
          display: flex
          flex-direction: column
          align-items: center
          flex-wrap: nowrap
</style>
